<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Fiche programme <router-link :to="{name: 'ProgramVue', params: {id: program.pk}}" v-if="program">({{program.name}})</router-link></span>
    </sticky>
    <div class="is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <program-form @submit="submit" :loading="loading"></program-form>
    </div>
      
      <!-- <div class="column is-2 is-3-widescreen is-4-fullhd is-padding-right">
        <div class="is-border is-radius-large" v-if="helperTitle || helperText">
          <div class="columns is-column is-border-bottom">
            <div class="column has-bg-light-darken-1 is-size-4">
              <b>Le saviez-vous ?</b>
            </div>
            <div class="column has-text-grey">
              <p><b>{{helperTitle}}</b></p>
              <p class="is-margin-top-small" style="white-space: pre-wrap;">{{helperText}}</p>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  <!-- </div> -->
</template>

<script>
  import ProgramForm from '@/components/program/ProgramForm'

  export default {
    name: 'ProgramCreate',
    data () {
      return {
        program: null,
        loading: false,
        helperTitle: null,
        helperText: null
      }
    },
    components: {
      ProgramForm
    },
    methods: {
      submit (program, isNew) {
        console.log(isNew)
        this.loading = true
        this.$api.programService.post(program).then(res => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Le programme a bien été créé'
          })
          if (!isNew) {
            this.$router.replace({name: 'ProgramVue', params: {id: res.data.pk}})
          } else {
            this.$router.replace({name: 'ProgramEdit', params: {id: res.data.pk}})
          }
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout du programme.'
          })
        })
      },
      getHelper () {
        if (this.$contentful) {
          this.$contentful.getEntry('8iImr9sPNmoM8KUImoMA4').then(entry => {
            this.helperTitle = entry.fields.title
            this.helperText = entry.fields.text
          })
        }
      }
    },
    created () {
      this.getHelper()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/ProgramCreate.vue